import { createApp } from 'vue'
import { DelphiPluginLoader } from '@/vue/plugin-common-plugins'

import RfpContainer from '@/features/RfpForm/RfpContainer.vue'
import type { GalaxyRfpConfig } from '@/AppRfp/types/GalaxyRfpFormItem'
import { getComponentData, getFormDefaultData } from './helpers/rfp-transform-data'
import { useGtm } from '@/composables/features/useGtm'
import { useConfigurations } from '@/stores/configurations'
import { fieldDateFormat } from '@/utils/transform-galaxy-data'

/**
 * 1/ We want to indicate to Typescript the type of elements
 * only present on this page.
 * This is why we don't use define declare global
 */
interface CustomWindow extends Window {
  db2RfpForm: GalaxyRfpConfig
}
const customWindow = window as unknown as CustomWindow
const { formStart } = useGtm()

export const createAppRfp = async (container: HTMLElement) => {
  const configuration = customWindow.db2RfpForm

  const appProps: InstanceType<typeof RfpContainer>['$props'] = {
    steps: getComponentData(configuration),
    defaultData: getFormDefaultData(configuration),
    successScreen: configuration.successScreen,
  }

  const app = createApp(RfpContainer, appProps)

  const VueCommonPlugins = await DelphiPluginLoader()
  app.use(VueCommonPlugins)

  const jsonSettings = configuration.getConfiguration()

  const configStore = useConfigurations()

  // GENERAL
  configStore.general.dateFormat = fieldDateFormat(jsonSettings.date_format_db2_id)
  configStore.general.firstDayOfTheWeek =
    jsonSettings.db2_first_day_week_id === 0 ? 'Monday' : 'Sunday'

  formStart(
    'contact',
    'rfp',
    'gaEventDelphiDirect',
    configuration.form.steps.length > 1
      ? configuration.form.steps.length + 'blocks'
      : configuration.form.steps.length + 'block',
  )
  app.mount(container)
}
